import React from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import Footer from '../components/Footer/Footer';

// const content = '../data/data-content.js';
import ContextContent from '../data/data-content';

const content = ContextContent;

const BaseLayout = ({ children, className }) => (
  <div content={content} className={className}>
    <Header content={ContextContent} />
    {React.cloneElement(children, { content })}
    <Footer content={content.footer} />
  </div>
);

const PageLayout = styled(BaseLayout)`
  margin: 0 auto;
  width: 95vw;
  max-width: 1366px;
  background: #ffffff;
`;

export default PageLayout;
